// extracted by mini-css-extract-plugin
export default {"container":"AddDocumentControl_container__s2pWK"};